import React from "react";
import {PlacedOrderOverview} from "@/data/entities/order";
import {DescriptionList, DescriptionListItem} from "peggirkit";
import {useIntl} from "react-intl";
import {formatMoney} from "@/utils/MoneyUtils";
import {twJoin} from "tailwind-merge";

type Props = {
    order: PlacedOrderOverview,
};

const PricingTotals = ({order}: Props) => {
    const intl = useIntl();

    console.log(order);

    return (
        <div className={"w-full flex flex-col gap-6 col-span-2"}>
            <DescriptionList
                containerClassname={twJoin("border border-gray-200 dark:border-slate-700 rounded-lg")}
                compact={true}
            >
                <DescriptionListItem
                    title={intl.formatMessage({id: "subtotal"})}
                    content={formatMoney(order.subtotal)}
                />
                <DescriptionListItem
                    title={intl.formatMessage({id: "deposit"})}
                    content={formatMoney(order.deposit)}
                />
                <DescriptionListItem
                    title={intl.formatMessage({id: "plasticFee"})}
                    content={formatMoney(order.supFee)}
                />
                {
                    (order.deliveryFee !== null && order.deliveryFee !== undefined) &&
                    <DescriptionListItem
                        title={intl.formatMessage({id: "deliveryFee"})}
                        content={formatMoney(order.deliveryFee)}
                    />
                }
                <DescriptionListItem
                    title={intl.formatMessage({id: "n-tip"}, {n: order.tipPercentage})}
                    content={formatMoney(order.tip)}
                />
                <DescriptionListItem
                    title={intl.formatMessage({id: "redeemedPoints"})}
                    content={order.redeemedLoyaltyPoints}
                />
                <DescriptionListItem
                    title={intl.formatMessage({id: "earnedPoints"})}
                    content={order.earnedLoyaltyPoints}
                />
                <DescriptionListItem
                    title={intl.formatMessage({id: "totalInclTax"})}
                    content={formatMoney(order.totalToPay)}
                />
            </DescriptionList>

            <DescriptionList
                containerClassname={twJoin("border border-gray-200 dark:border-slate-700 rounded-lg")}
                compact={true}
            >
                <DescriptionListItem
                    title={intl.formatMessage({id: "vatLowAmount"})}
                    content={formatMoney(order.vatLowAmount)}
                />
                <DescriptionListItem
                    title={intl.formatMessage({id: "vatLow"})}
                    content={formatMoney(order.vatLow)}
                />

                <DescriptionListItem
                    title={intl.formatMessage({id: "vatHighAmount"})}
                    content={formatMoney(order.vatHighAmount)}
                />
                <DescriptionListItem
                    title={intl.formatMessage({id: "vatHigh"})}
                    content={formatMoney(order.vatHigh)}
                />

                <DescriptionListItem
                    title={intl.formatMessage({id: "vatNone"})}
                    content={order.vatNoneAmount}
                />
            </DescriptionList>
        </div>
    );
};

export default PricingTotals;